import Image from "next/image";

// components
import Link from "@/components/Link";

// assets
import weriLogo from "@/assets/images/landing/logo/weri-logo.png";
import LogoWhite from "@/components/icons/LoLiveLogoIcon";

import styles from "@/assets/styles/components/Header/HirerHeader/index.module.scss"


const HirerHeaderLogo = () => {
  switch (true) {
    case process.env.NEXT_PUBLIC_APP_WL_CODE === "WERI":
      return (
        <Link href="/">
          <Image
            width={125}
            height={68}
            src={weriLogo}
            alt="WeRi"
            className={styles["locl-hirer-header-logo__weri"]}
          />
        </Link>
      );
    default:
      return (
        <Link href="/lolive">
          <LogoWhite className={styles["locl-hirer-header-logo__core"]} />
        </Link>
      );
  }
};

export default HirerHeaderLogo;
